import PropTypes from 'prop-types';
import keys from "ramda/es/keys";
import cx from "ramda-extension/es/cx";
import keyMirror from "ramda-extension/es/keyMirror";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'Text';
export const typeConstants = keyMirror({
    PRIMARY: null,
    SECONDARY: null,
    DISABLED: null,
    ERROR: null,
    WARNING: null
});
export const weightConstants = keyMirror({
    THIN: null,
    LIGHT: null,
    REGULAR: null,
    MEDIUM: null,
    BOLD: null,
    BLACK: null
});
const Text = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { type = typeConstants.PRIMARY, weight, elementParagraph = false, children, italic, dark, ...other } = props;
    const textProps = {
        ...other,
        className: cx('Text', {
            'Text--typeItalic': italic,
            'Text--darkTheme': dark,
            'Text--primary': type === Text.typeConstants.PRIMARY,
            'Text--secondary': type === Text.typeConstants.SECONDARY,
            'Text--disabled': type === Text.typeConstants.DISABLED,
            'Text--typeError': type === Text.typeConstants.ERROR,
            'Text--typeWarning': type === Text.typeConstants.WARNING,
            'Text--weightThin': weight === Text.weightConstants.THIN,
            'Text--weightLight': weight === Text.weightConstants.LIGHT,
            'Text--weightRegular': weight === Text.weightConstants.REGULAR,
            'Text--weightMedium': weight === Text.weightConstants.MEDIUM,
            'Text--weightBold': weight === Text.weightConstants.BOLD,
            'Text--weightBlack': weight === Text.weightConstants.BLACK
        }, props.className)
    };
    if (elementParagraph) {
        return /*#__PURE__*/ React.createElement("p", textProps, children);
    } else {
        return /*#__PURE__*/ React.createElement("span", textProps, children);
    }
};
Text.displayName = 'Text';
Text.propTypes = {
    /**
	 * Any children node can be included inside the `Text` element.
	 */ children: PropTypes.node,
    /**
	 * Additional className selector that can be applied.
	 */ className: PropTypes.string,
    /**
	 * Is text dark?
	 */ dark: PropTypes.bool,
    /**
	 * Is element type of paragraph? Default element is span.
	 */ elementParagraph: PropTypes.bool,
    /**
	 * Is text italic?
	 */ italic: PropTypes.bool,
    /**
	 * One of constants: 'PRIMARY', 'SECONDARY', 'DISABLED', 'ERROR', 'WARNING'
	 */ type: PropTypes.oneOf(keys(typeConstants)),
    /**
	 * One of weight constants:
	 */ weight: PropTypes.oneOf(keys(weightConstants))
};
Text.typeConstants = typeConstants;
Text.weightConstants = weightConstants;
export default Text;
